/**
 *  call this component when close case and not order case
 */
import React, { FC, useEffect } from "react"
import { useParams } from "react-router-dom"

import { useAppDispatch } from "../../../../core/app/hooks"
import {
  unlockCaseApi,
} from "../../../../core/app/slices/clinical/clinicalThunkApi"

interface noPopupType {
  isActive: boolean
  showPrompt: boolean | (() => void)
  confirmNavigation: boolean | (() => void)
  uploadAllData
  isClickOrder: boolean
}
const NoPopup: FC<noPopupType> = ({
  isActive,
  showPrompt,
  confirmNavigation,
  uploadAllData,
  isClickOrder,
}) => {
  const dispatch = useAppDispatch()
  const { caseId, patientId } = useParams()

  useEffect(() => {
    if (isActive && showPrompt)
      uploadAllData({
        callback: () => {
          // if (!isClickOrder) {
          dispatch(unlockCaseApi({ patientId, caseId })).then(() => {
            confirmNavigation()
          })
          // }
        },
      })
  }, [isActive, showPrompt])

  return <></>
}
export default NoPopup
